import { t } from '@hefe/i18n';
import { TaskEvent, TaskEventType } from '@hefe/models';
import { TasksSlice } from '@hefe/store';
import { formatDateTime } from '@hefe/utils';
import { Col, Row } from 'antd';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../store/store';
import CustomTable from '../../../../core/components/table/custom-table.component';
import { useEffect } from 'react';

interface TasksAutoAssignmentWizardEventsComponentProps {
  events: TaskEvent[];
}

export default function TasksAutoAssignmentWizardEventsComponent(
  props: TasksAutoAssignmentWizardEventsComponentProps
) {
  const dispatch = useAppDispatch();

  const wizard = useSelector(TasksSlice.autoAssignmentWizardSelector);

  useEffect(() => {
    if (wizard.eventIds.length === 0) {
      dispatch(
        TasksSlice.actions.setWizardEventIds(
          props.events.map((event) => event.id)
        )
      );
    }
  }, []);

  return (
    <Row gutter={[0, 16]}>
      <Col span={24}>
        <CustomTable
          name="auto-assignment-wizard-events-table"
          key="auto-assignment-wizard-events-table"
          rowKey="id"
          columns={[
            {
              key: 'date',
              title: t('date'),
              dataIndex: 'date',
              default: true,
              render: (value: string) => formatDateTime(value),
            },
            {
              key: 'description',
              title: t('description'),
              dataIndex: 'description',
              default: true,
              render: (value: string, event: TaskEvent) =>
                event.type === TaskEventType.BASKETBALL_GAME
                  ? value
                  : t('practice'),
            },
            {
              key: 'location',
              title: t('location'),
              dataIndex: 'location',
              default: true,
            },
          ]}
          dataSource={props.events}
          hideColumnSelector
          rowSelection
          initSelectedRowKeys={
            wizard.eventIds.length > 0
              ? wizard.eventIds
              : props.events.map((event) => event.id)
          }
          onRowSelect={(selectedRowKeys) =>
            dispatch(TasksSlice.actions.setWizardEventIds(selectedRowKeys))
          }
        />
      </Col>
    </Row>
  );
}
